//TYPES
export const INIT_OMNI_STATE = 'INIT_OMNI_STATE';
export const CHANGE_OMNI_STATE = 'CHANGE_OMNI_STATE';
export const SHOW_OMNI_POPUP = 'SHOW_OMNI_POPUP';
export const HIDE_OMNI_POPUP = 'HIDE_OMNI_POPUP';
export const SEARCH_FP_JSON_DATA = 'SEARCH_FP_JSON_DATA';
export const SEARCH_FP_JSON_DATA_SUCCESS = 'SEARCH_FP_JSON_DATA_SUCCESS';
export const SAVE_FP_JSON_DATA = 'SAVE_FP_JSON_DATA';
export const SAVE_FP_REAL_NAME_DATA = 'SAVE_FP_REAL_NAME_DATA';
export const OMNI_SEARCH_SIGNATURE_DATA = 'OMNI_SEARCH_SIGNATURE_DATA';
export const OMNI_SEARCH_DOC_DATA_JSON = 'OMNI_SEARCH_DOC_DATA_JSON';
export const OMNI_SAVE_SIGN_BOTH_DATA = 'OMNI_SAVE_SIGN_BOTH_DATA';
export const OMNI_SAVE_SIGNATURE_DATA = 'OMNI_SAVE_SIGNATURE_DATA';
export const OMNI_SAVE_SIGNATURE_DATA_SUCCESS =
  'OMNI_SAVE_SIGNATURE_DATA_SUCCESS';
export const SAVE_INTERVIEW_DATA = 'SAVE_INTERVIEW_DATA';
export const SEND_SMS_OMNI = 'SEND_SMS_OMNI';
export const JSON_DATA_TO_XML = 'JSON_DATA_TO_XML';
export const REGISTER_REPORT_TO_JOBLIST = 'REGISTER_REPORT_TO_JOBLIST';
export const CANCEL_SEND_OMNI = 'CANCEL_SEND_OMNI';
export const REGISTER_INTERVIEW_TO_JOBLIST = 'REGISTER_INTERVIEW_TO_JOBLIST';
export const OMNI_SEARCH_PLAN_DETAIL = 'OMNI_SEARCH_PLAN_DETAIL';
export const SEARCH_ESTABLISH_INFO = 'SEARCH_ESTABLISH_INFO';
export const SEARCH_ESTABLISH_INFO_SUCCESS = 'SEARCH_ESTABLISH_INFO_SUCCESS';
export const GET_OMNI_PRODUCT_DETAIL = 'GET_OMNI_PRODUCT_DETAIL';
export const SET_OMNI_PRODUCT_DETAIL = 'SET_OMNI_PRODUCT_DETAIL';
export const CHANGE_OMNI_FP_REPORT = 'CHANGE_OMNI_FP_REPORT';
export const GET_OMN_PUBLISH_PLAN_INFO_OMNI = 'GET_OMN_PUBLISH_PLAN_INFO_OMNI';
export const SAVE_FP_REPORT_SHARED_LP = 'SAVE_FP_REPORT_SHARED_LP';

// ACTIONS
// STATE 초기화
export const initOmniState = () => {
  return { type: INIT_OMNI_STATE };
};
// STATE 변경
export const changeOmniState = payload => {
  return { type: CHANGE_OMNI_STATE, payload };
};
// 옴니 팝업 노출
export const showOmniPopup = () => {
  return { type: SHOW_OMNI_POPUP };
};
// 옴니 팝업 숨김
export const hideOmniPopup = () => {
  return { type: HIDE_OMNI_POPUP };
};
// 설계사 보고서 JSON DATA 조회
export const searchFpJsonData = payload => {
  return { type: SEARCH_FP_JSON_DATA, payload };
};
// 설계사 보고서 JSON DATA 저장
export const saveFpJsonData = payload => {
  return { type: SAVE_FP_JSON_DATA, payload };
};
// 전자청약 JSON DATA 불러오기
export const loadEaDocDataJson = data => {
  return { type: OMNI_SEARCH_DOC_DATA_JSON, payload: data };
};
// 전자서명, 성명 저장
export const omniSaveSignBothData = data => {
  return { type: OMNI_SAVE_SIGN_BOTH_DATA, payload: data };
};
// 전자서명 저장
export const omniSaveSignatureData = data => {
  return { type: OMNI_SAVE_SIGNATURE_DATA, payload: data };
};
// 전자서명 조회
export const omniSearchSignatureData = data => {
  return { type: OMNI_SEARCH_SIGNATURE_DATA, payload: data };
};
// 대면확인서 저장
export const saveInterviewData = payload => {
  return { type: SAVE_INTERVIEW_DATA, payload };
};
// 옴니청약 모바일 전송
export const sendSmsOmni = payload => {
  return { type: SEND_SMS_OMNI, payload };
};
// 설계사 보고서 XML 생성
export const jsonDataToXml = payload => {
  return { type: JSON_DATA_TO_XML, payload };
};
// 보고서 잡리스트 등록
export const registerReportToJoblist = payload => {
  return { type: REGISTER_REPORT_TO_JOBLIST, payload };
};
// 옴니청약 발송 취소
export const cancelSendOmni = payload => {
  return { type: CANCEL_SEND_OMNI, payload };
};
// 대면확인서 잡리스트 등록
export const registerInterviewToJoblist = payload => {
  return { type: REGISTER_INTERVIEW_TO_JOBLIST, payload };
};
// 옴니 설계 조회
export const omniSearchPlanDetail = payload => {
  return { type: OMNI_SEARCH_PLAN_DETAIL, payload };
};
// 옴니 상품 상세 조회
export const getOmniProductDetail = payload => {
  return { type: GET_OMNI_PRODUCT_DETAIL, payload };
};
// 상품 상세 세팅
export const setOmniProductDetail = payload => {
  return { type: SET_OMNI_PRODUCT_DETAIL, payload };
};
// 옴니 fpReport 데이터 수정
export const changeOmniFpReport = payload => {
  return { type: CHANGE_OMNI_FP_REPORT, payload };
};
// 비교안내문(517) 계약 정보 조회
export const getOmnPublishPlanInfoOmni = payload => {
  return { type: GET_OMN_PUBLISH_PLAN_INFO_OMNI, payload };
};
// 공동청약 정보 fpReport용 docDataJson (docType: 2)에 저장
export const saveFpReportSharedLp = payload => {
  return { type: SAVE_FP_REPORT_SHARED_LP, payload };
};
